import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'your instruction',
  tone: 'bg-white text-obsidian border-mist',
  iconTone: 'bg-rescue/10 text-rescue-deep',
  subTone: 'text-graphite'
}, {
  icon: CpuIcon,
  label: 'AI',
  sub: 'ChatGPT · Claude · Gemini · DeepSeek',
  tone: 'bg-obsidian text-ice border-obsidian',
  iconTone: 'bg-rescue/15 text-rescue ring-1 ring-rescue/30',
  subTone: 'text-steel'
}, {
  icon: FileCheck2Icon,
  label: 'Result',
  sub: 'a structured draft to review',
  tone: 'bg-white text-obsidian border-crimson/25',
  iconTone: 'bg-crimson/10 text-crimson',
  subTone: 'text-graphite'
}];
export function PromptFlow() {
  return <div className="mt-10 flex flex-col items-stretch gap-3 md:flex-row md:items-center md:justify-center" aria-label="How a prompt works" data-id="element-250" data-mp="34ijzotylzdvm">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-251" data-mp="1a62h3zopt1xb" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3.5 md:w-64 ${n.tone}`} data-id="element-252" data-mp="1a756g36e2wb4">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-253" data-mp="1f1tgg4hqba87">
              <n.icon className="h-5 w-5" aria-hidden="true" data-id="element-254" data-mp="1a775g2fk7jon" />
            </span>
            <div className="min-w-0" data-id="element-255" data-mp="157ugnc54o2jf">
              <p className="font-display text-base font-extrabold" data-id="element-256" data-mp="10bcfem90ambu">{n.label}</p>
              <p className={`text-xs ${n.subTone}`} data-id="element-257" data-mp="1xykunzieyz5e">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-rescue-deep md:mx-0 md:rotate-0" aria-hidden="true" data-id="element-258" data-mp="1sz8a5lf0m45z" />}
        </React.Fragment>)}
    </div>;
}